import { getParishAndCity } from './states';

export const services = {
  getParishAndCity,
};
